import React from "react"
import { FeaturesContext, TenantFeatures } from "../Features"

const devFeature = (defaultValue: boolean) => import.meta.env.VITE_ENV === "dev" || defaultValue

const defaultFeatures: TenantFeatures = {
  site_reservation: devFeature(false),
  customer_advanced: devFeature(false),
  servicing: false,
  plan_with_ai: devFeature(false),
  asset_forecast: devFeature(false),
  asset_forecast_debug: devFeature(false),
  customer_reporting: devFeature(true),
  installation_forecast: devFeature(false),
  calendar_sites: devFeature(false),
  system_node_graphs: devFeature(false),
  system_node_v2: devFeature(false),
  asset_depletion: false,
  user_reports: devFeature(false),
  orders_activityless: devFeature(false),
  demo_dashboard_vmi: devFeature(false),
  // Hide-reports flags default to false (reports shown). Not dev-gated: dev
  // should never auto-hide reports.
  hide_reports_asset: false,
  hide_reports_system: false,
  // On in local dev only; enable per tenant once Load Precedence is live end to end.
  ac_load: devFeature(false),
}

export type Feature = keyof TenantFeatures

export function useGetFeature(feature: Feature): boolean {
  const context = React.useContext(FeaturesContext)

  const contextFeature = Object.entries(context?.features ?? {}).find(([key]) => key === feature)?.[1]
  const defaultFeature = Object.entries(defaultFeatures).find(([key]) => key === feature)?.[1]

  if (typeof contextFeature === "boolean") {
    return contextFeature
  } else if (typeof defaultFeature === "boolean") {
    return defaultFeature
  }

  return false
}

/**
 * Returns true if asset depletion UI should be shown.
 * Depletion is enabled when either `asset_depletion` or `asset_forecast` is true.
 */
export function useDepletionEnabled(): boolean {
  const assetDepletion = useGetFeature("asset_depletion")
  const assetForecast = useGetFeature("asset_forecast")
  return assetDepletion || assetForecast
}
